import { render, staticRenderFns } from "./MobilhazProduct.vue?vue&type=template&id=2de2247c&scoped=true&"
import script from "./MobilhazProduct.vue?vue&type=script&lang=js&"
export * from "./MobilhazProduct.vue?vue&type=script&lang=js&"
import style0 from "./MobilhazProduct.vue?vue&type=style&index=0&id=2de2247c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de2247c",
  null
  
)

export default component.exports